
export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAM_6gtjY4sWF7sQE5Pxu4EeCcIYV2GXCY",
    authDomain: "umakeit-12f98.firebaseapp.com",
    databaseURL: "https://umakeit-12f98.firebaseio.com",
    projectId: "umakeit-12f98",
    storageBucket: "",
    messagingSenderId: "594926894551"
  }
};
